import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuthService from "../session/AuthService";

const RequireAuth = ({ allowedRoles }) => {
  const authUserType = useAuthService.getUserType();
  const userType = allowedRoles?.includes(authUserType.toString());
  const location = useLocation();

  return (
    // authUserType?.roles?.find(role => allowedRoles?.includes(role))
    userType ? (
      <Outlet />
    ) : !userType ? (
      <Navigate to="/unauthorized" state={{ from: location }} replace />
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    )
  );
};

export default RequireAuth;
